export default __webpack_public_path__ + "static/media/computer-with-homepage.0d8ab819.jpg";